import IcOK from 'assets/images/backoffice/capital/ic-ok-hand.svg';
import React from 'react';
import ListItem from '../ListItem';
import InfoCard from './InfoCard';
import styles from './InfoCard.css';

function BenefitInvestment() {
  return (
    <InfoCard
      title="Keuntungan Moka Capital Investment"
      icon={<img src={IcOK} className={styles.shield} />}
    >
      <div className={styles['wrapper-why-capital']}>
        <ListItem>Pendanaan hingga Rp10 miliar</ListItem>
        <ListItem>Terhubung dengan lebih dari 40.000 Investor</ListItem>
        <ListItem>Sistem pembayaran bagi hasil</ListItem>
      </div>
    </InfoCard>
  );
}

export default BenefitInvestment;
